import React, { useEffect, useState } from 'react';
import { Snackbar } from '@mui/material';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
));

export default function SnackbarComponent({
  isSnackbarOpen,
  setSnackbar,
  snackbarText,
  snackbarType
}: {
  isSnackbarOpen: boolean;
  setSnackbar: (snackbarState: boolean) => void;
  snackbarText: string;
  snackbarType: AlertColor;
}) {
  // Handler for snackbar
  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(false);
  };

  return (
    <Snackbar
      open={isSnackbarOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbarType}
        sx={{ width: '100%' }}
      >
        {snackbarText}
      </Alert>
    </Snackbar>
  );
}
